import {
  ofType
} from 'redux-observable';

import {
  ajax
} from "rxjs/ajax";

import { of } from 'rxjs';

import {
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';

import {
  FETCH_POIS,
  FETCH_POIS_ERROR,
  SET_POIS,
} from '../constants';


const pois = (action$, state$) => action$.pipe(
  ofType(FETCH_POIS),
  switchMap(() => ajax({
      url: `${state$.value.auth.server}/pois/${
        state$.value.insightsCriteria.insightType === 'organisation' &&
        state$.value.insightsCriteria.organisation.value
        ? `${
          state$.value.insightsCriteria.organisation.value
        }`
        : ''
      }`,
      headers: {
        Authorization: state$.value.auth.token,
      },
      responseType: 'json',
      crossDomain: true,
    }).pipe(
      map(response => {

        return ({
          type: SET_POIS,
          data: response.response,
        })
      }),
      catchError(error => of({
        type: FETCH_POIS_ERROR,
        error,
      }))
    ))
);

export default pois;
